export * from "./InputLabel"
export { default } from "./InputLabel"
